/**
 * 获取深度链接请求参数
 */
export const DDL_CODE_KEY = 'ddlCode'
